import { render, staticRenderFns } from "./Proposal.vue?vue&type=template&id=237bbf6c&scoped=true&style=display%3A%20flex"
import script from "./Proposal.vue?vue&type=script&lang=js"
export * from "./Proposal.vue?vue&type=script&lang=js"
import style0 from "./Proposal.vue?vue&type=style&index=0&id=237bbf6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237bbf6c",
  null
  
)

export default component.exports